/**
 * ProtectedVendorRoute — Route guard for Vendor Portal
 * Only allows vendor-role users.
 */
import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useVendorAuth } from '../hooks/useVendorAuth';
import { portalPath } from '@/shared/app/portalPath';

export default function ProtectedVendorRoute({ children }: { children: ReactNode }) {
  const { profile, loading, isAuthenticated } = useVendorAuth();
  const location = useLocation();
  const p = portalPath('vendor');

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="h-8 w-8 animate-spin mx-auto text-primary" />
          <p className="mt-4 text-sm text-muted-foreground">Verifying vendor access...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated || !profile) {
    return <Navigate to={p('/login')} state={{ from: location.pathname }} replace />;
  }

  return <>{children}</>;
}
